import { zonoApi } from '../api/zonoApi';

export const channelApi = zonoApi.injectEndpoints({
  endpoints: (builder) => ({
    publishToBot: builder.mutation<
      any,
      { sellerWorkspaceId?: string; body: any }
    >({
      query: ({ sellerWorkspaceId, body }) => ({
        url: `hub/bot/api/v1/messages`,
        method: 'POST',
        params: {
          sellerWorkspaceId,
        },
        body,
      }),
    }),
  }),
});

export const { usePublishToBotMutation } = channelApi;
